export default __webpack_public_path__ + "static/media/listed-icon.052dec07.svg";